import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import { productCardImageSize } from 'commons/constants';
const ModularCollectionThumbnail = props => {
  const $ = _c(24);
  let t0;
  if ($[0] !== props.imageSize || $[1] !== props.layout) {
    t0 = () => {
      if (!props.imageSize) {
        const layoutSizes = {
          minimal: 265,
          thumbnail: 38
        };
        return layoutSizes[props.layout] ?? 368;
      }
      const productCardSizes = {
        [productCardImageSize.small]: 265,
        [productCardImageSize.medium]: 368,
        [productCardImageSize.large]: 600,
        [productCardImageSize.modular]: 100,
        [productCardImageSize.thumb]: 36
      };
      return productCardSizes[props.imageSize] ?? 368;
    };
    $[0] = props.imageSize;
    $[1] = props.layout;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getImageWidthFromSize = t0;
  const {
    altText,
    hasOrientationRight: t1,
    image,
    imageLoaded,
    imageSize: t2,
    layout,
    listName,
    setImageLoaded: t3,
    setLazy: t4,
    isModularSofasPage: t5
  } = props;
  const hasOrientationRight = t1 === undefined ? false : t1;
  const imageSize = t2 === undefined ? "" : t2;
  const setImageLoaded = t3 === undefined ? _temp : t3;
  const setLazy = t4 === undefined ? false : t4;
  const isModularSofasPage = t5 === undefined ? false : t5;
  const src = image;
  let t6;
  if ($[3] !== getImageWidthFromSize) {
    t6 = getImageWidthFromSize();
    $[3] = getImageWidthFromSize;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const widthSize = t6;
  const t7 = !isModularSofasPage;
  const t8 = layout !== "minimal" || !!listName;
  const t9 = layout === "minimal" && !listName;
  let t10;
  if ($[5] !== hasOrientationRight || $[6] !== imageLoaded || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
    t10 = classNames("object-contain", {
      "m-5": t7,
      "opacity-100": imageLoaded,
      "flipped-right": hasOrientationRight,
      "max-w-[85%] max-h-[47.5%]": t8,
      "max-h-full max-w-full": t9
    });
    $[5] = hasOrientationRight;
    $[6] = imageLoaded;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== setImageLoaded || $[12] !== src) {
    t11 = () => {
      setImageLoaded(true, src);
    };
    $[11] = setImageLoaded;
    $[12] = src;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = imageSize && !setLazy || ["thumb", "modular"].includes(imageSize) ? false : setLazy ? true : undefined;
  let t13;
  if ($[14] !== altText || $[15] !== t10 || $[16] !== t11 || $[17] !== t12 || $[18] !== widthSize) {
    t13 = {
      className: t10,
      trim: "color",
      width: widthSize,
      onLoad: t11,
      trimPad: 20,
      lazy: t12,
      alt: altText
    };
    $[14] = altText;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = widthSize;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  const commonImageProps = t13;
  if (!src) {
    return null;
  }
  let t14;
  if ($[20] !== commonImageProps || $[21] !== src || $[22] !== widthSize) {
    t14 = <JBImage {...commonImageProps} src={src} loader={false} fit="clip" width={widthSize} height={widthSize} />;
    $[20] = commonImageProps;
    $[21] = src;
    $[22] = widthSize;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
};
ModularCollectionThumbnail.propTypes = {
  altText: PropTypes.string,
  displayOptionImages: PropTypes.bool,
  firstPopularImage: PropTypes.string,
  forceFallback: PropTypes.bool,
  hasOrientationRight: PropTypes.bool,
  image: PropTypes.string,
  imageLoaded: PropTypes.bool,
  imageSize: PropTypes.string,
  isModularSofasPage: PropTypes.bool,
  layout: PropTypes.string,
  listName: PropTypes.string,
  productCategory: PropTypes.string,
  productImageOptionTypeId: PropTypes.number,
  productImages: PropTypes.shape({
    transparent_config_image: PropTypes.string,
    transparent_hero_image_ts: PropTypes.string
  }),
  setImageLoaded: PropTypes.func,
  setLazy: PropTypes.bool
};
export default ModularCollectionThumbnail;
function _temp() {}